import React from "react";
import "./Footer.css";

// 🔹 Local logo
import logo from "../images/logo2.jpg";

// 🔹 Icons
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Left Section */}
        <div className="footer-about animate">
          <img src={logo} alt="Karveer Library" className="footer-logo" />
          <h3> कै. रघुनाथ रामचंद्र बुरांडे ग्रंथालय</h3>
          <p>
           महाराष्ट्र शासन – डॉ. बाबासाहेब आंबेडकर उत्कृष्ट ग्रंथालय पुरस्कार प्राप्त
          </p>

          <div className="social-icons">
             <a
               href="https://www.instagram.com/rrburandegranthalay?igsh=NTQ0OTI5dGtlY2c4&utm_source=qr
 "
              target="_blank"
               rel="noopener noreferrer"
               >
             <FaInstagram className="social-icon" />
             </a>
            
            

             <a href="#" target="_blank" rel="noopener noreferrer">
               <FaFacebookF />
               </a>

            <a href="#" target="_blank" rel="noopener noreferrer">
                  <FaTwitter />
               </a>
          </div>
        </div>

        {/* Middle Section */}
        <div className="footer-links animate delay">
          <h4>जलद दुवे</h4>
          <ul>
            <li>› Home</li>
            <li>› आमच्याविषयी</li>
            <li>› उपक्रम व कार्यक्रम</li>
            <li>› चित्रकृती </li>
            <li>› प्रकाशने </li>
            <li>› ध्येय व उद्दिष्टे</li>
             <li>›संपर्क</li>
            <li>› देणगी</li>
          </ul>
        </div>

        {/* Right Section */}
        <div className="footer-contact animate delay2">
          <h4>संपर्क</h4>

          <div className="contact-box">
            <p>
              <strong>पत्ता</strong><br />
               कोडोली, ता. पन्हाळा,<br />
              कोल्हापूर ४१६००२
            </p>

            <p>
              <strong>फोन</strong><br />
               ८७६६५६९१०१ / ७५८८५७७२०९
            </p>

            <p>
              <strong>ईमेल</strong><br />
              rrburandegranthalay@gmail.com
            </p>
          </div>
        </div>

      </div>

      

            {/* Bottom Copyright Strip */}
      <div className="footer-strip">
        <div className="strip-left">
          © कॉपीराइट २००९ – २०२६ |कै. रघुनाथ रामचंद्र बुरांडे ग्रंथालय | सर्व हक्क राखीव
        </div>

        <div className="strip-right">
          वेब डिझाईन : Comptrance Technology, कोल्हापूर
          <span className="views">
            पृष्ठ भेटी : २४९० | एकूण अभ्यागत : १५०८१
          </span>
        </div>

        <button
          className="scroll-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          ↑
        </button>
      </div>

    </footer>
  );
};

export default Footer;
